import useTranslation from 'next-translate/useTranslation';

import { Text } from '~/domains/design-system/Text';

import getOrdinalNumber from '../../../utils/getOrdinalNumber';

import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  worst: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translate(-50%, 0)',
    background: theme.white,
    zIndex: 3,
    minWidth: '80px',
    textAlign: 'center',
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    filter: 'drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.1))',
    clipPath: 'inset(2px -20px -20px -20px)',

    '& span': {
      color: theme.colors.gray[6],
      zIndex: 4,
    },
  },

  triangle1: {
    position: 'absolute',
    left: -20,
    width: 0,
    height: 0,
    borderLeft: '20px solid transparent',
    borderRight: '20px solid transparent',

    borderTop: `20px solid ${theme.white}`,
  },
  triangle2: {
    position: 'absolute',
    right: -20,
    width: 0,
    height: 0,
    borderLeft: '20px solid transparent',
    borderRight: '20px solid transparent',

    borderTop: `20px solid ${theme.white}`,
  },
}));

type PlayerCardDropYourWorstProps = {
  dropWorstNth: number;
};

function PlayerCardDropYourWorst({ dropWorstNth }: PlayerCardDropYourWorstProps) {
  const { t } = useTranslation('contest');

  const { classes } = useStyles();

  const ordinal = getOrdinalNumber(dropWorstNth);
  const message = t('gamecenter.player.common.playerCard.dropWorstNth__hasPlural', {
    count: dropWorstNth,
    ordinal,
  });

  return (
    <div className={classes.worst}>
      <div className={classes.triangle1} />
      <Text variant="headline-x-small">{message}</Text>
      <div className={classes.triangle2} />
    </div>
  );
}

export default PlayerCardDropYourWorst;
